import { Moment } from "moment";

export function getMomentMidday(aMoment: Moment) {
    return aMoment.startOf('day').add(12, 'hours');
  }